(() => {
  const DELIVERY_PATH = '/pages/choisir-mon-point-relais';
  const BUTTON_LABEL = 'Valider mon panier — modifier ma livraison';
  const TERMS_STORAGE_KEY = 'flyandbag:cart-terms-accepted';
  const STYLE_ID = 'FlyAndBagCartTermsStyles';
  const CHECKOUT_SELECTOR = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    '[data-checkout-button]',
    'a[href*="/checkout"]',
    'button[formaction*="/checkout"]',
    'form[action*="/checkout"] button[type="submit"]',
  ].join(',');

  const shopRoot = () => window.Shopify?.routes?.root || '/';

  const routeUrl = (path) => {
    const root = shopRoot().replace(/\/+$/, '');
    return `${root}/${String(path).replace(/^\/+/, '')}`.replace(/\/{2,}/g, '/');
  };

  const deliveryUrl = () => routeUrl(DELIVERY_PATH);
  const isDeliveryPage = () => window.location.pathname.endsWith(DELIVERY_PATH);

  const termsAccepted = () => {
    try {
      return sessionStorage.getItem(TERMS_STORAGE_KEY) === 'true';
    } catch {
      return false;
    }
  };

  const saveTermsAccepted = (accepted) => {
    try {
      sessionStorage.setItem(TERMS_STORAGE_KEY, accepted ? 'true' : 'false');
    } catch {}
  };

  const ensureStyles = () => {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      #cart-drawer [data-fab-drawer],
      #cart-drawer .fly-relay-drawer-card {
        display: none !important;
      }

      #cart-drawer .additional-checkout-buttons,
      #cart-drawer shopify-accelerated-checkout-cart {
        display: none !important;
      }

      #cart-drawer .fly-cart-terms {
        display: grid;
        grid-template-columns: 22px minmax(0, 1fr);
        gap: 10px;
        align-items: center;
        width: 100%;
        box-sizing: border-box;
        border: 1px solid rgba(36, 185, 215, 0.55);
        border-radius: 12px;
        background: #ffffff;
        color: #1b1f3b;
        padding: 13px 14px;
        cursor: pointer;
        transition: border-color .18s ease, box-shadow .18s ease, background .18s ease;
      }

      #cart-drawer .fly-cart-terms:hover,
      #cart-drawer .fly-cart-terms:focus-within {
        border-color: #24b9d7;
        background: #f7fdfe;
        box-shadow: 0 0 0 3px rgba(36, 185, 215, 0.12);
      }

      #cart-drawer .fly-cart-terms.is-required {
        border-color: #ff4fb3;
        box-shadow: 0 0 0 3px rgba(255, 79, 179, 0.12);
      }

      #cart-drawer .fly-cart-terms__input {
        position: absolute;
        width: 1px;
        height: 1px;
        opacity: 0;
        pointer-events: none;
      }

      #cart-drawer .fly-cart-terms__box {
        display: grid;
        width: 22px;
        height: 22px;
        place-items: center;
        box-sizing: border-box;
        border: 1.5px solid rgba(27, 31, 59, 0.45);
        border-radius: 6px;
        background: #ffffff;
        color: #ffffff;
      }

      #cart-drawer .fly-cart-terms__input:checked + .fly-cart-terms__box {
        border-color: #24b9d7;
        background: #24b9d7;
      }

      #cart-drawer .fly-cart-terms__input:checked + .fly-cart-terms__box::after {
        width: 10px;
        height: 6px;
        border-bottom: 2px solid currentColor;
        border-left: 2px solid currentColor;
        content: '';
        transform: rotate(-45deg) translateY(-1px);
      }

      #cart-drawer .fly-cart-terms__text {
        font-size: .76rem;
        line-height: 1.42;
      }

      #cart-drawer .fly-cart-terms__text a {
        color: inherit;
        font-weight: 750;
        text-decoration: underline;
        text-underline-offset: 2px;
      }

      #cart-drawer .cart__checkout-button:disabled {
        cursor: not-allowed !important;
        opacity: .45 !important;
        filter: saturate(.65);
      }

      #cart-drawer .cart__checkout-button:not(:disabled) {
        cursor: pointer !important;
        opacity: 1 !important;
        filter: none !important;
      }
    `;
    document.head.appendChild(style);
  };

  const unlockDeliveryInputs = () => {
    document
      .querySelectorAll(
        '[data-fly-delivery] input[name="city"], [data-fly-delivery] input[name="zipCode"]'
      )
      .forEach((input) => {
        if (!(input instanceof HTMLInputElement)) return;
        input.disabled = false;
        input.readOnly = false;
        input.removeAttribute('disabled');
        input.removeAttribute('readonly');
        input.removeAttribute('aria-disabled');
        input.style.setProperty('pointer-events', 'auto', 'important');
        input.style.setProperty('user-select', 'text', 'important');
        input.style.setProperty('-webkit-user-select', 'text', 'important');
      });
  };

  const checkoutControl = (element) => {
    if (!(element instanceof Element)) return null;
    return element.closest(CHECKOUT_SELECTOR);
  };

  const changeLabel = (control) => {
    if (!(control instanceof Element)) return;

    control.dataset.flyandbagRelayGate = 'true';
    control.setAttribute('aria-label', BUTTON_LABEL);

    if (control instanceof HTMLInputElement) {
      if (control.value !== BUTTON_LABEL) control.value = BUTTON_LABEL;
      return;
    }

    const textTarget = control.querySelector(
      '.button-text, [data-button-text], .cart__checkout-text, span'
    );

    if (textTarget && textTarget.childElementCount === 0) {
      if (textTarget.textContent.trim() !== BUTTON_LABEL) {
        textTarget.textContent = BUTTON_LABEL;
      }
      return;
    }

    if (control.childElementCount === 0 && control.textContent.trim() !== BUTTON_LABEL) {
      control.textContent = BUTTON_LABEL;
    }
  };

  const buildTermsBox = () => {
    const label = document.createElement('label');
    label.className = 'fly-cart-terms';
    label.dataset.flyCartTerms = 'true';

    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.className = 'fly-cart-terms__input';
    checkbox.dataset.flyCartTermsInput = 'true';
    checkbox.checked = termsAccepted();
    checkbox.setAttribute('aria-label', 'J’accepte les conditions générales de vente');

    const box = document.createElement('span');
    box.className = 'fly-cart-terms__box';
    box.setAttribute('aria-hidden', 'true');

    const text = document.createElement('span');
    text.className = 'fly-cart-terms__text';
    text.append('J’ai lu et j’accepte les ');

    const link = document.createElement('a');
    link.href = routeUrl('/policies/terms-of-service');
    link.target = '_blank';
    link.rel = 'noopener';
    link.textContent = 'conditions générales de vente';
    link.addEventListener('click', (event) => event.stopPropagation());

    text.append(link, '.');
    label.append(checkbox, box, text);
    return label;
  };

  const syncDrawerTerms = () => {
    ensureStyles();

    const drawer = document.querySelector('#cart-drawer');
    if (!drawer) return;

    drawer
      .querySelectorAll('[data-fab-drawer], .fly-relay-drawer-card')
      .forEach((element) => element.remove());

    const ctas = drawer.querySelector('.cart__ctas');
    if (!ctas) return;

    let terms = ctas.parentElement?.querySelector(':scope > [data-fly-cart-terms]');
    if (!(terms instanceof HTMLElement)) {
      terms = buildTermsBox();
      ctas.before(terms);
    }

    const checkbox = terms.querySelector('[data-fly-cart-terms-input]');
    const accepted = checkbox instanceof HTMLInputElement ? checkbox.checked : termsAccepted();

    ctas.querySelectorAll(CHECKOUT_SELECTOR).forEach((control) => {
      changeLabel(control);
      if (
        control instanceof HTMLButtonElement ||
        control instanceof HTMLInputElement
      ) {
        control.disabled = !accepted;
        control.setAttribute('aria-disabled', accepted ? 'false' : 'true');
      }
    });
  };

  const syncAll = () => {
    ensureStyles();
    unlockDeliveryInputs();
    document.querySelectorAll(CHECKOUT_SELECTOR).forEach(changeLabel);
    syncDrawerTerms();
  };

  const requireDrawerTerms = (control) => {
    if (!(control instanceof Element) || !control.closest('#cart-drawer')) return true;

    const checkbox = document.querySelector(
      '#cart-drawer [data-fly-cart-terms-input]'
    );

    if (checkbox instanceof HTMLInputElement && checkbox.checked) return true;

    const terms = document.querySelector('#cart-drawer [data-fly-cart-terms]');
    terms?.classList.add('is-required');
    terms?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    window.setTimeout(() => terms?.classList.remove('is-required'), 1400);
    checkbox?.focus();
    return false;
  };

  const keepOnDeliveryPage = () => {
    const drawer = document.querySelector('#cart-drawer');
    if (drawer && typeof drawer.close === 'function') {
      drawer.close();
    } else {
      document.querySelector(
        '#cart-drawer [data-close-button], #cart-drawer button[aria-label*="Fermer"], #cart-drawer .dialog-close-button'
      )?.click();
    }

    document.querySelector('[data-fly-delivery]')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  document.addEventListener('change', (event) => {
    const checkbox =
      event.target instanceof HTMLInputElement &&
      event.target.matches('[data-fly-cart-terms-input]')
        ? event.target
        : null;

    if (!checkbox) return;

    saveTermsAccepted(checkbox.checked);
    checkbox.closest('[data-fly-cart-terms]')?.classList.remove('is-required');
    syncDrawerTerms();
  });

  document.addEventListener(
    'click',
    (event) => {
      const control = checkoutControl(event.target);
      if (!control) return;

      if (!requireDrawerTerms(control)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (isDeliveryPage()) {
        keepOnDeliveryPage();
        return;
      }

      window.location.assign(deliveryUrl());
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target instanceof HTMLFormElement ? event.target : null;
      const submitter = event.submitter;
      const checkoutSubmitter = checkoutControl(submitter);
      const checkoutForm = form && /\/checkout(?:[/?#]|$)/.test(form.action || '');

      if (!checkoutSubmitter && !checkoutForm) return;

      const control = checkoutSubmitter || form?.querySelector(CHECKOUT_SELECTOR);
      if (control && !requireDrawerTerms(control)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (isDeliveryPage()) {
        keepOnDeliveryPage();
        return;
      }

      window.location.assign(deliveryUrl());
    },
    true
  );

  let scheduled = false;
  const scheduleSync = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      syncAll();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll, { once: true });
  } else {
    syncAll();
  }

  window.addEventListener('pageshow', syncAll);
  document.addEventListener('shopify:section:load', syncAll);

  new MutationObserver(scheduleSync).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
